export const DEFAULT_NFT_TIER = { minHoldings: 1, normalTickets: 1, goldenTickets: 0 };

export function normalizeNftTiers(row) {
  if (Array.isArray(row?.tiers) && row.tiers.length) {
    return row.tiers
      .map((t) => ({
        minHoldings: Math.max(1, parseInt(t.minHoldings, 10) || 1),
        normalTickets: Math.max(0, parseInt(t.normalTickets, 10) || 0),
        goldenTickets: Math.max(0, parseInt(t.goldenTickets, 10) || 0),
      }))
      .sort((a, b) => a.minHoldings - b.minHoldings);
  }
  const normal = Math.max(0, parseInt(row?.normalTickets ?? row?.dailyTickets, 10) || 0);
  const golden = Math.max(0, parseInt(row?.goldenTickets, 10) || 0);
  return [{ minHoldings: 1, normalTickets: normal, goldenTickets: golden }];
}

export function resolveTierForHoldings(row, holdingsCount) {
  const count = Math.max(0, Math.floor(Number(holdingsCount) || 0));
  if (count <= 0) return null;
  const tiers = normalizeNftTiers(row);
  let best = null;
  for (const t of tiers) {
    if (count >= t.minHoldings) best = t;
  }
  return best;
}

export function nftRowHasGoldenConfigured(row) {
  return normalizeNftTiers(row).some((t) => (parseInt(t.goldenTickets, 10) || 0) > 0);
}

export function nftRowHasNormalConfigured(row) {
  return normalizeNftTiers(row).some((t) => (parseInt(t.normalTickets, 10) || 0) > 0);
}

export function formatTierLadder(row) {
  const tiers = normalizeNftTiers(row);
  if (!tiers.length) return '';
  return tiers.map((t) => `${t.minHoldings}+`).join(' · ');
}
